<script>
import TablePage from '@/found/components/table_page';

export default {
  name: 'dealer_scan_list',
  extends: TablePage,
  data() {
    return {
      params: {},
    };
  },
  props: {
    propsObj: Object,
  },
  async created() {
    this.params = { banquetCode: this.propsObj.row.banquetCode };
    await this.getConfigList('scan_list');
  },
  methods: {

  },
};
</script>
